import React from "react";

import Moment from "react-moment";
import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
import PostCard from "../PostCard";

const { companyService } = mtzApis;

function PostList({ posts, onUpdate, onDelete, total }) {
    let modalEditCompPostRef = React.useRef();
    let [activePost, setActivePost] = React.useState(0);


    return (
        <>
            <h5 className="mtz-h5">
                <u>Posts:</u> {total && <span>{total}</span>}
            </h5>
            {
                posts && posts.length === 0 &&
                <div className="mtz-text-center mtz-text-muted">No posts found</div>
            }

            {
                posts && posts.map((post, i) => (
                    <PostCard key={i} post={post} onUpdate={onUpdate} onDelete={onDelete} />
                ))
            }
        </>
    );
}


function LikeButton({ post, onNewPostState }) {
    const me = React.useContext(AuthContext);
    let [likeStats, setLikeStats] = React.useState();
    let [loading, setLoading] = React.useState(false);
    let [myLike, setMyLike] = React.useState();

    React.useEffect(() => {
        setLikeStats({ ...post.likeStats });
        setMyLike({ ...post.myLike });
    }, [post]);

    const createLike = async () => {
        setLoading(true);
        let like = { postId: post.id, userId: me.userId };
        let created = await companyService.createPostLike(like);
        setLoading(false);

        if (onNewPostState) {
            let updatedPost = { ...post };
            updatedPost.myLike = created;
            updatedPost.likeStats.all.count++;
            onNewPostState(updatedPost);
        }
    }

    const deleteLike = async (like) => {
        setLoading(true);
        let deleted = await companyService.deletePostLikeById(like.id);
        setLoading(false);

        if (onNewPostState) {
            let updatedPost = { ...post };
            updatedPost.myLike = null;
            updatedPost.likeStats.all.count--;
            onNewPostState(updatedPost);
        }
    }

    return (
        <button className={"btn btn-link " + (myLike && Object.keys(myLike).length > 0 ? 'text-primary' : 'text-dark')} onClick={async () => {
            let founds = await companyService.getPostLikes(new URLSearchParams({ postIds: post.id, userIds: me.userId }));
            if (founds && founds.length > 0)
                deleteLike(founds[0]);
            else
                createLike();
        }}>
            {
                !loading ?
                    <span>
                        <i className="fa fa-thumbs-up"></i> Like {likeStats && likeStats.all.count > 0 ? `(${likeStats.all.count})` : ''}
                    </span> :
                    <i className="fa fa-spinner fa-spin"></i>
            }
        </button>
    );
}

function ShareButton({ post }) {
    const link = `${window.location.origin}/posts/${post.id}` || '';
    let [copied, setCopied] = React.useState(false);

    return (
        <>
            <button className="btn btn-link text-dark" data-toggle='modal' data-target={`#modal-share-post-${post.id}`}>
                <i className="fa fa-share"></i> Share
            </button>

            {/* modal to share copy link */}
            <div className="modal" id={`modal-share-post-${post.id}`}>
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header d-flex align-items-center">
                            <h5 className="modal-title">Share Post</h5>
                            <button type="button" className="close" data-dismiss='modal'>
                                <span>&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="d-flex mtz-gap-4 align-items-center">
                                <input type="text" className="shadow-sm w-100 form-control" defaultValue={link || ''} />
                                <button className="btn btn-outline-primary" onClick={() => {
                                    navigator.clipboard.writeText(link);
                                    setCopied(true);
                                    setTimeout(() => setCopied(false), 3000);
                                }}>
                                    <i className="fa fa-copy"></i>
                                </button>
                                {
                                    copied &&
                                    <div className="text-success">Copied</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function CommentButton({ post }) {
    let [commentStats, setCommentStats] = React.useState();

    React.useEffect(() => {
        setCommentStats(post.commentStats);
    }, [post]);

    return (
        <button className="flex-fill btn btn-link text-dark"
            data-toggle='collapse' data-target={`#collapse-add-comment-${post.id}`}>
            <i className="fa fa-comment"></i> Comment {commentStats && commentStats.all.count > 0 ? `(${commentStats.all.count})` : ''}
        </button>
    );
}

function CommentManager({ post, onNewPostState }) {
    let [newComment, setNewComment] = React.useState({});
    let [activeComment, setActiveComment] = React.useState();
    let [changes, setChanges] = React.useState({});
    let [comments, setComments] = React.useState([]);
    let [loading, setLoading] = React.useState(false);
    const me = React.useContext(AuthContext);

    React.useEffect(() => {
        init();
    }, [post]);

    const init = async () => {
        await loadComments();
    }

    const loadComments = async () => {
        let cmts = await companyService.getPostComments(new URLSearchParams({ postIds: post.id }));
        if (cmts) {
            cmts = await loadCommentInfo(cmts);
            setComments(cmts);
        }
    }

    const loadCommentInfo = async (items) => {
        let ownerIds = items.map(c => c.ownerId);
        let users = await companyService.getUsers(new URLSearchParams({ userIds: ownerIds }));
        let userMap = {};
        users.forEach(u => userMap[u.id] = u);
        items.forEach(c => {
            c.owner = userMap[c.ownerId];
        });
        return items;
    }

    const createComment = async e => {
        e.preventDefault();

        setLoading(true);
        let created = await companyService.createPostComment({ ...newComment, postId: post.id });
        setLoading(false);

        if (created) {
            let cmts = await loadCommentInfo([created]);
            created = cmts[0];
            setComments([created, ...comments]);
            setNewComment({});
            if (onNewPostState) {
                let updatedPost = { ...post };
                updatedPost.commentStats = post.commentStats || { all: { count: 0 } };
                updatedPost.commentStats.all.count = updatedPost.commentStats.all.count + 1;
                onNewPostState(updatedPost);
            }
        }
    };

    const deleteComment = async (comment) => {
        setLoading(true);
        let deleted = await companyService.deletePostCommentById(comment.id);
        setLoading(false);

        if (deleted) {
            setComments(comments.filter(c => c.id !== comment.id));
            if (onNewPostState) {
                let updatedPost = { ...post };
                updatedPost.commentStats.all.count--;
                onNewPostState(updatedPost);
            }
        }
    }

    const updateComment = async () => {
        setLoading(true);
        let updated = await companyService.updatePostCommentById(activeComment.id, { content: activeComment.content });
        setLoading(false);

        if (updated) {
            setComments(comments.map(c => c.id === activeComment.id ? { ...c, content: activeComment.content } : c));
            setActiveComment();
        }
    }

    return (
        <div className="mtz-gap-16 d-flex flex-column">
            <form onSubmit={createComment} className="w-100 text-center">
                <div className="d-flex mtz-gap-4 mx-3">
                    <input type="text" className="shadow-sm w-100 form-control" placeholder="Write a comment..." disabled={loading}
                        value={newComment.content || ''} onChange={(e) => setNewComment({ content: e.target.value })} />

                    <button className="btn btn-outline-primary" disabled={loading == true}>
                        <i className="fa fa-paper-plane"></i>
                    </button>
                </div>
            </form>

            {
                (!comments || comments.length === 0) &&
                <div className="text-center text-muted">No comments found</div>
            }

            {
                comments && comments.map((c, i) => (
                    <div key={i} className="mtz-card-body mtz-shadow-sm mtz-bg-white mtz-rounded d-flex flex-column mtz-gap-16">
                        <div className="d-flex align-items-center">
                            {
                                c.owner && c.owner.logo ?
                                    <img src={c.owner && c.owner.logo ?
                                        companyService.getBackendHost() + c.owner.logo :
                                        '/assets/images/empty.png'}
                                        className="p-1 border shadow rounded-circle"
                                        style={{ width: '40px', height: '40px' }}
                                    /> :
                                    <i className="text-muted fa fa-user-circle" style={{ fontSize: '40px' }}></i>
                            }

                            <div className="mx-2 mtz-p-8 bg-light mtz-rounded-8 flex-grow-1">
                                <div className="mtz-text-muted">
                                    {c.owner && `${c.owner.firstname} ${c.owner.lastname}`}</div>
                                <div>
                                    {
                                        activeComment && activeComment.id === c.id ?
                                            <div className="d-flex mtz-gap-4">
                                                <input type="text" className="shadow-sm w-100 form-control" value={activeComment.content}
                                                    onChange={(e) => setActiveComment({ ...activeComment, content: e.target.value })} />
                                                <button className="btn btn-outline-primary" onClick={updateComment}>
                                                    <i className="fa fa-paper-plane"></i>
                                                </button>
                                            </div> :
                                            c.content
                                    }
                                </div>
                                <div className="mtz-text-muted text-right"><small><i><Moment fromNow>{c.createdAt}</Moment></i></small></div>
                            </div>

                            {
                                me && me.userId === c.ownerId &&
                                <div className="dropdown">
                                    <button className="btn btn-light mtz-cursor-pointer" data-toggle='dropdown'>
                                        <i className="fa fa-ellipsis-v"></i>
                                    </button>
                                    <div className="dropdown-menu">
                                        <button className="dropdown-item text-primary" onClick={() => setActiveComment(c)}>
                                            Edit
                                        </button>
                                        <button className="dropdown-item text-danger" onClick={() => deleteComment(c)}>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                ))
            }
        </div>
    )
}

export default PostList;